export default __webpack_public_path__ + "app/images/icons/add-user-button.png";